import { g as m } from "./index767.mjs";
import { p as c } from "./index787.mjs";
import { i as O } from "./index761.mjs";
import { i as R } from "./index770.mjs";
import { i as f } from "./index831.mjs";
import { w as C } from "./index760.mjs";
import { e as l } from "./index834.mjs";
import { e as p } from "./index819.mjs";
var u = m, r = c, N = O, T = R, _ = f, I = C, v = l, t = p;
r && r.prototype;
var V = I("species"), e = !1, E = N(u.PromiseRejectionEvent), P = T("Promise", function() {
  var i = _(r), n = i !== String(r);
  if (!n && t === 66)
    return !0;
  if (!t || t < 51 || !/native code/.test(i)) {
    var a = new r(function(o) {
      o(1);
    }), s = function(o) {
      o(function() {
      }, function() {
      });
    }, S = a.constructor = {};
    if (S[V] = s, e = a.then(function() {
    }) instanceof s, !e)
      return !0;
  }
  return !n && (v === "BROWSER" || v === "DENO") && !E;
}), d = {
  CONSTRUCTOR: P,
  REJECTION_EVENT: E,
  SUBCLASSING: e
};
export {
  d as p
};
